export default [
  {name: 'Moins de 5 metros', value: 0},
  {name: 'Plus de 5 metros', value: 1},
]



// WEBPACK FOOTER //
// ./src/shared/routers/languages/fr/arrays/length.js